
// Czas pracy
import ReportingAndAnalysis from '@/views/ReportingAndAnalysis/Index'
import ReportingAndAnalysisReports from '@/views/ReportingAndAnalysis/Reports/Index'
import ReportingAndAnalysisReportsReports from '@/views/ReportingAndAnalysis/Reports/Reports'
import ReportingAndAnalysisReportsDailyReportsShiftSummaries from '@/views/ReportingAndAnalysis/Reports/DailyReportsShiftSummaries/Index'
import ReportingAndAnalysisReportsDailyReportsShiftSummariesDailyReportsShiftSummaries from '@/views/ReportingAndAnalysis/Reports/DailyReportsShiftSummaries/DailyReportsShiftSummaries'
import ReportingAndAnalysisReportsDailyReportsShiftSummariesDetailedReports from '@/views/ReportingAndAnalysis/Reports/DailyReportsShiftSummaries/DetailedReports'

// Dzienne raporty szczegółowe (nadawanie) zarządzającego
import ReportingAndAnalysisDailyShipmentsReportsShiftSummariesDetailedShipmentsReports from '@/views/ReportingAndAnalysis/Reports/DailyReportsShiftSummaries/DetailedShipmentsReports'

// Pojedynczy raport szczegółowy
import ReportsCommonReport from '@/views/Reports/Common/Report'

// Pojedynczy raport szczegółowy nadawania
import ReportsCommonShipmentReport from '@/views/Reports/Common/ShipmentReport'

// Ranking pracowników
import ReportingAndAnalysisReportsUsersRanking from '@/views/ReportingAndAnalysis/Reports/UsersRanking/Index'

// Raport wykonanych płyt
import ReportingAndAnalysisPrepress from '@/views/ReportingAndAnalysis/Prepress/Index'
import ReportingAndAnalysisPrepressPrepress from '@/views/ReportingAndAnalysis/Prepress/Prepress'
import ReportingAndAnalysisPrepressReportPlates from '@/views/ReportingAndAnalysis/Prepress/ReportPlates'
import ReportingAndAnalysisPrepressReportAdditionalPlates from '@/views/ReportingAndAnalysis/Prepress/ReportAdditionalPlates'

// Wykresy zamówień
import ReportingAndAnalysisOrders from '@/views/ReportingAndAnalysis/Orders/Index'
import ReportingAndAnalysisOrdersOrders from '@/views/ReportingAndAnalysis/Orders/Orders'
import ReportingAndAnalysisOrdersSentOrders from '@/views/ReportingAndAnalysis/Orders/SentOrders'
import ReportingAndAnalysisOrdersSentOrdersSimple from '@/views/ReportingAndAnalysis/Orders/SentOrdersSimple'
import ReportingAndAnalysisOrdersPlacedOrders from '@/views/ReportingAndAnalysis/Orders/PlacedOrders'
import ReportingAndAnalysisOrdersWeeklySentOrders from '@/views/ReportingAndAnalysis/Orders/WeeklySentOrders'
import ReportingAndAnalysisOrdersMonthlySentOrders from '@/views/ReportingAndAnalysis/Orders/MonthlySentOrders'
import ReportingAndAnalysisOrdersOrdersInProgress from '@/views/ReportingAndAnalysis/Orders/OrdersInProgress'


// Raporty zleceń
import ReportingAndAnalysisJobs from '@/views/ReportingAndAnalysis/Jobs/Index'
import ReportingAndAnalysisJobsJobs from '@/views/ReportingAndAnalysis/Jobs/Jobs'
import ReportingAndAnalysisJobsNCFJobs from '@/views/ReportingAndAnalysis/Jobs/NCFJobs'


// Raporty druku

import ReportingAndAnalysisPrint from '@/views/ReportingAndAnalysis/Index'
import ReportingAndAnalysisPrintPrint from '@/views/ReportingAndAnalysis/Print/Print'

// Ranking pracowników
import ReportingAndAnalysisReportsReportsSummaries from '@/views/ReportingAndAnalysis/Reports/ReportsSummaries/Index'


export default [
    {
        path: '/reporting-and-analysis',
        name: 'reportingAndAnalysis',
        component: ReportingAndAnalysis,
        meta: {
            title: 'Raporty & Analizy',
            menuRendered: true,
            menuTitle: 'Raporty & Analizy',
            icon: 'mdi-chart-line'
        },
        children: [
            {
                path: '/reporting-and-analysis/prepress',
                name: 'reportingAndAnalysisPrepress',
                component: ReportingAndAnalysisPrepress,
                meta: {
                    title: 'Raporty & Analizy / Prepress',
                    menuRendered: true,
                    menuTitle: 'Prepress',
                    requiresAuth: true,
                    permission: 'reports_analysis_read',
                },
                redirect: { name: 'ReportingAndAnalysisPrepressPrepress' },
                children: [
                    {
                        path: '/reporting-and-analysis/prepress',
                        name: 'ReportingAndAnalysisPrepressPrepress',
                        component: ReportingAndAnalysisPrepressPrepress,
                        meta: {
                            title: 'Raporty & Analizy / Raport wykonanych płyt',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/prepress/report-plates',
                        name: 'reportingAndAnalysisPrepressReportPlates',
                        component: ReportingAndAnalysisPrepressReportPlates,
                        meta: {
                            title: 'Raporty & Analizy / Raport wykonanych płyt',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/prepress/report-additional-plates',
                        name: 'reportingAndAnalysisPrepressReportAdditionalPlates',
                        component: ReportingAndAnalysisPrepressReportAdditionalPlates,
                        meta: {
                            title: 'Raporty & Analizy / Płyty dodatkowe',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                ]
            },
            {
                path: '/reporting-and-analysis/orders',
                name: 'reportingAndAnalysisOrders',
                component: ReportingAndAnalysisOrders,
                meta: {
                    title: 'Raporty & Analizy / Zamówienia',
                    menuRendered: true,
                    menuTitle: 'Zamówienia',
                    requiresAuth: true,
                    permission: 'reports_analysis_read',
                },
                redirect: { name: 'reportingAndAnalysisOrdersOrders' },
                children: [
                    {
                        path: '/reporting-and-analysis/orders',
                        name: 'reportingAndAnalysisOrdersOrders',
                        component: ReportingAndAnalysisOrdersOrders,
                        meta: {
                            title: 'Raporty & Analizy / Zamówienia',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/orders/sent-orders',
                        name: 'reportingAndAnalysisOrdersSentOrders',
                        component: ReportingAndAnalysisOrdersSentOrders,
                        meta: {
                            title: 'Raporty & Analizy / Zamówienia / Zamówienia nadane',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/orders/sent-orders-simple',
                        name: 'reportingAndAnalysisOrdersSentOrdersSimple',
                        component: ReportingAndAnalysisOrdersSentOrdersSimple,
                        meta: {
                            title: 'Raporty & Analizy / Zamówienia / Zamówienia nadane',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/orders/placed-orders',
                        name: 'reportingAndAnalysisOrdersPlacedOrders',
                        component: ReportingAndAnalysisOrdersPlacedOrders,
                        meta: {
                            title: 'Raporty & Analizy / Zamówienia / Zamówienia - realizacja (d)',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/orders/weekly-placed-orders',
                        name: 'reportingAndAnalysisOrdersWeeklySentOrders',
                        component: ReportingAndAnalysisOrdersWeeklySentOrders,
                        meta: {
                            title: 'Raporty & Analizy / Zamówienia / Zamówienia - realizacja (w)',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/orders/monthly-placed-orders',
                        name: 'reportingAndAnalysisOrdersMonthlySentOrders',
                        component: ReportingAndAnalysisOrdersMonthlySentOrders,
                        meta: {
                            title: 'Raporty & Analizy / Zamówienia / Zamówienia - realizacja (m)',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/orders/production-in-progress',
                        name: 'reportingAndAnalysisOrdersOrdersInProgress',
                        component: ReportingAndAnalysisOrdersOrdersInProgress,
                        meta: {
                            title: 'Raporty & Analizy / Zamówienia / Produkcja w toku',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                ]
            },
            {
                path: '/reporting-and-analysis/reports',
                name: 'reportingAndAnalysisReports',
                component: ReportingAndAnalysisReports,
                meta: {
                    title: 'Raporty & Analizy / Czas pracy',
                    menuRendered: true,
                    menuTitle: 'Czas pracy',
                    requiresAuth: true,
                    permission: 'reports_review',
                },
                redirect: { name: 'reportingAndAnalysisReportsReports' },
                children: [
                    {
                        path: '/reporting-and-analysis/reports',
                        name: 'reportingAndAnalysisReportsReports',
                        component: ReportingAndAnalysisReportsReports,
                        meta: {
                            title: 'Raporty & Analizy / Czas pracy',
                            requiresAuth: true,
                            permission: 'reports_review',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/reports/daily-reports-shift-summaries',
                        name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummaries',
                        component: ReportingAndAnalysisReportsDailyReportsShiftSummaries,
                        meta: {
                            title: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy',
                            menuTitle: 'Rozliczenia czasu pracy',
                            requiresAuth: true,
                            permission: 'reports_review',
                        },
                        redirect: { name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDailyReportsShiftSummaries' },
                        children: [
                            {
                                path: '/reporting-and-analysis/reports/daily-reports-shift-summaries',
                                name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDailyReportsShiftSummaries',
                                component: ReportingAndAnalysisReportsDailyReportsShiftSummariesDailyReportsShiftSummaries,
                                meta: {
                                    title: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy',
                                    requiresAuth: true,
                                    permission: 'reports_review',
                                },
                            },
                            {
                                path: '/reporting-and-analysis/reports/daily-reports-shift-summaries/:id',
                                name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDetailedReports',
                                component: ReportingAndAnalysisReportsDailyReportsShiftSummariesDetailedReports,
                                meta: {
                                    title: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy / Raporty szczegółowe',
                                    requiresAuth: true,
                                    permission: 'reports_review',
                                },
                            },
                            {
                                path: '/reporting-and-analysis/reports/daily-reports-shift-summaries/:reportShiftSummaryId/reports/:id',
                                name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDetailedReportsReport',
                                component: ReportsCommonReport,
                                meta: {
                                    title: 'Raporty & Analizy / Czas pracy /  Rozliczenia czasu pracy / Raporty szczegółowe / Raport',
                                    requiresAuth: true,
                                    permission: 'reports_review',
                                },
                            },
                            {
                                path: '/reporting-and-analysis/reports/daily-shipments-reports-shift-summaries/:id',
                                name: 'reportingAndAnalysisReportsReportsDailyShipmentsReportsShiftSummariesDetailedShipmentsReports',
                                component: ReportingAndAnalysisDailyShipmentsReportsShiftSummariesDetailedShipmentsReports,
                                meta: {
                                    title: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy / Raporty szczegółowe',
                                    requiresAuth: true,
                                    permission: 'reports_review',
                                },
                            },
                            {
                                path: '/reporting-and-analysis/reports/daily-shipments-reports-shift-summaries/:reportShiftSummaryId/:id',
                                name: 'reportingAndAnalysisReportsReportsDailyShipmentsReportsShiftSummariesDetailedReportsShipmentReport',
                                component: ReportsCommonShipmentReport,
                                meta: {
                                    title: 'Raporty & Analizy / Czas pracy / Rozliczenia czasu pracy / Raporty szczegółowe / Raport',
                                    requiresAuth: true,
                                    permission: 'reports_review',
                                },
                            },
                        ],
                    },
                    {
                        path: '/reporting-and-analysis/reports/users-ranking',
                        name: 'reportingAndAnalysisReportsUsersRanking',
                        component: ReportingAndAnalysisReportsUsersRanking,
                        meta: {
                            title: 'Raporty & Analizy / Czas pracy / Rankingi',
                            menuTitle: 'Rankingi',
                            requiresAuth: true,
                            permission: 'user_ranking_admin_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/reports/summaries',
                        name: 'reportingAndAnalysisReportsReportsSummaries',
                        component: ReportingAndAnalysisReportsReportsSummaries,
                        meta: {
                            title: 'Raporty & Analizy / Czas pracy / Podsumowania / Raporty',
                            menuTitle: 'Podsumowania / Raporty',
                            requiresAuth: true,
                            permission: 'reports_review',
                        },
                    },
                ]
            },
            {
                path: '/reporting-and-analysis/jobs',
                name: 'reportingAndAnalysisJobs',
                component: ReportingAndAnalysisJobs,
                meta: {
                    title: 'Raporty & Analizy / Zlecenia',
                    menuRendered: true,
                    menuTitle: 'Zlecenia',
                    requiresAuth: true,
                    permission: 'reports_analysis_read',
                },
                redirect: { name: 'reportingAndAnalysisJobsJobs' },
                children: [
                    {
                        path: '/reporting-and-analysis/jobs',
                        name: 'reportingAndAnalysisJobsJobs',
                        component: ReportingAndAnalysisJobsJobs,
                        meta: {
                            title: 'Raporty & Analizy / Zamówienia',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    {
                        path: '/reporting-and-analysis/jobs/ncf-jobs',
                        name: 'reportingAndAnalysisJobsNCFJobs',
                        component: ReportingAndAnalysisJobsNCFJobs,
                        meta: {
                            title: 'Raporty & Analizy / Zlecenia / Zlecenia NCF',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                    
                ]
            },
            {
                path: '/reporting-and-analysis/print',
                name: 'reportingAndAnalysisPrint',
                component: ReportingAndAnalysisPrint,
                meta: {
                    title: 'Raporty & Analizy / Druk',
                    menuRendered: true,
                    menuTitle: 'Druk',
                    requiresAuth: true,
                    permission: 'reports_analysis_read',
                },
                redirect: { name: 'reportingAndAnalysisPrintPrint' },
                children: [
                    {
                        path: '/reporting-and-analysis/print',
                        name: 'reportingAndAnalysisPrintPrint',
                        component: ReportingAndAnalysisPrintPrint,
                        meta: {
                            title: 'Raporty & Analizy / Druk',
                            requiresAuth: true,
                            permission: 'reports_analysis_read',
                        },
                    },
                ]
            },
        ],
    },
]